import { render, staticRenderFns } from "./cargo.vue?vue&type=template&id=3c9fdc01"
import script from "./cargo.vue?vue&type=script&lang=js"
export * from "./cargo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports